// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__22H0m","paramInput":"JobSimulator_paramInput__2y9dn","input":"JobSimulator_input__3tE0f"};